/**
 * IsFutureDateTime
 *
 * Module for checking if a give time is in the future
 *
 * @return {boolean}
 */

OT.createNS('OT.Search.Helpers.isFutureDateTime');

OT.Search.Helpers.isFutureDateTime = function(time) {

	if(OT.Common.Helpers.isMobile().Windows()) {
		return true;
	}

    return time > moment().format('X');

};
